export default __webpack_public_path__ + "static/media/Graph_SMP-High.936122cb.svg";